import { Ref } from 'vue'
import { useI18n } from 'vue-i18n'

export const useInitDefaultConfig = () => {
  const { t } = useI18n()

  const initDefaultConfig = (props: {
    closeModal: () => void
    loading: Ref
    handleConfirm: () => void
    showCancelButton?: boolean
    showConfirmButton?: boolean
    cancelDisabled?: boolean
    confirmDisabled?: boolean
    confirmText?: string
  }) => {
    const {
      closeModal,
      loading,
      handleConfirm,
      showCancelButton = true,
      showConfirmButton = true,
      cancelDisabled = false,
      confirmDisabled = false,
      confirmText = t('form.confirm'),
    } = props
    const footer = () => (
      <div class="footer">
        {showCancelButton && (
          <el-button
            class="btn-footer btn-cancel"
            type="primary"
            onClick={() => closeModal()}
            loading={loading.value}
            disabled={cancelDisabled}
          >
            {t('form.cancel')}
          </el-button>
        )}
        {showConfirmButton && (
          <el-button
            class="btn-footer btn-confirm"
            type="primary"
            onClick={() => handleConfirm()}
            loading={loading.value}
            disabled={confirmDisabled}
          >
            {confirmText}
          </el-button>
        )}
      </div>
    )

    return {
      footer,
    }
  }

  return {
    initDefaultConfig,
  }
}
